<app-header-container [includeBanner]="includeBanner" [isSystemBanner]="isSystemBanner">
  <div header-content [style.background-color]="'white'">
    <div *ngIf="!isLoading; else loading" class="d-flex flex-column gap-3">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <div class="header-text">{{ headerTitle }}</div>
          <app-status-pill *ngIf="statusPill" [statusPill]="statusPill" />
          <app-status-pill *ngIf="secondaryStatusPill" [statusPill]="secondaryStatusPill" />
          <ng-content select="[header-title-addon]"></ng-content>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <div class="d-flex flex-column gap-3">
        <lib-loading-shimmer [height]="'1.125rem'" [width]="'25rem'" />
        <lib-loading-shimmer [height]="'1.5rem'" [width]="'18rem'" />
      </div>
    </ng-template>
  </div>
  <div *ngIf="includeBanner" banner-content>
    <ng-content></ng-content>
  </div>
</app-header-container>
